import {useQuery} from "react-query";
import {ResidentService} from "../../../services/ResidentServices";
import {Resident} from "../types";

/**
 * The resident a workflow belongs to, if any.
 *
 * This used to be two chained requests: one for the mapping, then one for the resident it
 * named. The endpoint answers with the resident itself now.
 */
export const useFetchLinkedResident = (
  workflowId: string,
): {
  data?: Resident;
  /** Remove the query to prevent stale data. */
  remove: () => void;
  isFetching: boolean;
} => {
  const {data, remove, isFetching} = useQuery(
    ["linked_resident", workflowId],
    async () => {
      const {data: resident} = await ResidentService.getResidentByWorkflow(
        workflowId,
      );

      return resident ?? undefined;
    },
    {
      enabled: !!workflowId,
    },
  );

  return {data, remove, isFetching};
};
